<form [formGroup]="ruleForm">
  <div class="sharing-rule-input">
    <div class="input-column-wrapper">
      <label class="input-spacing"><b>Rule Name</b></label>
      <input
        type="text"
        pInputText
        class="input-field-width"
        formControlName="ruleName"
        id="rule-name">
    </div>
    <div class="input-column-wrapper">
      <label class="input-spacing"><b>Source Account</b></label>
      <p-select
        formControlName="sourceAccount"
        placeholder="Select Source Account"
        [options]="this.config.data.sourceAccountOptions"
        [filter]="true"
        filterBy="label,value"
        [filterFields]="['label','value']"
        [resetFilterOnHide]="true"
        class="input-field-width"
        id="source-account">
        <ng-template let-item pTemplate="item">
          <span class="source-account-item">
            <span>{{ item.label }}</span> <small class="p-text-secondary">ID: {{ item.value }}</small>
          </span>
        </ng-template>
      </p-select>
    </div>
  </div>
  <app-shared-offer-set-rules-filter
    [ruleForm]="ruleForm"
    controlName="globalFilter"
    label="Make Filters"
    [panelIndex]="0"
    [propertyValueFilters]="globalFilters"
    [makes]="makes">
  </app-shared-offer-set-rules-filter>
  <app-shared-offer-set-rules-filter
    [ruleForm]="ruleForm"
    controlName="offerSetFilter"
    [panelIndex]="1"
    label="Offer Set Filters"
    [propertyValueFilters]="offerFilters">
  </app-shared-offer-set-rules-filter>
  <app-shared-offer-set-rules-filter
    [ruleForm]="ruleForm"
    controlName="accountFilter"
    label="Target Account Filters"
    [panelIndex]="2"
    [propertyValueFilters]="accountFilters"
    [sourceAccountOptions]="this.config.data.targetAccountOptions">
  </app-shared-offer-set-rules-filter>
  <div class="confirm-button-field">
    <div class="cancel-confirm-buttons">
      <div class="cancel-preview-buttons-position">
        <p-button  type="button" class="cancel-button-field" severity="secondary" label="Cancel" (click)="closeModal()"></p-button>
        <button
          pButton
          type="button"
          [disabled]="checkDisabledConfirmButton()"
          class="p-button-success"
          label="Preview"
          (click)="previewFilters()">
        </button>
        @if (ruleProcessing) {
          <p-progressSpinner [style]="{height: '2.5rem'}" strokeWidth="8"></p-progressSpinner>
        }
      </div>
      <div>
        @if (isInvalidForm()) {
          <div class="input-validation-wrapper">
            <small class="p-d-block p-error block">The Rule Name and Source Account must be filled out in order to save.</small>
          </div>
        }
        @if (hasDuplicateRuleName()) {
          <div class="input-validation-wrapper">
            <small class="p-d-block p-error block">This Rule Name already exists.</small>
          </div>
        }
        @if (hasEmptyFilterFields() && !isInvalidForm()) {
          <div class="input-validation-wrapper">
            <small class="p-d-block p-error block">At least one filter must be added and all filter fields must be filled out.</small>
          </div>
        }
      </div>
    </div>
  </div>
</form>
